import { graphql } from 'app/generated/gql'

export const SEND_SMS_MUTATION = graphql(`
  mutation SendSms($input: SendMessageInput!) {
    sendSms(input: $input) {
      id
      orgId
      workspaceId
      locationId
      threadId
      from
      to
      callerId
      sentByUserId
      isAgent
      aiWorkflowId
      aiWorkflowName
      isInitialMessage
      contactId
      channel
      subject
      text
      read
      archived
      createdDate
      updatedDate
      status
      providerMessageId
      errorCode
      errorMessage
    }
  }
`)

export const THREAD_EVENTS_QUERY = graphql(`
  query ThreadEvents($search: String, $sort: SortInput, $pagination: PaginationInput) {
    events(search: $search, sort: $sort, pagination: $pagination) {
      hits {
        id
        data
        createdDate
      }
    }
  }
`)

export const SMS_OPT_OUT_QUERY = graphql(`
  query SmsOptOut($search: String, $pagination: PaginationInput) {
    optOuts(search: $search, pagination: $pagination) {
      total
    }
  }
`)

// Which provider this location's outbound SMS goes through. Only CallRail
// appends an opt-out line to a conversation's first message, so the inbox has
// to know before it can claim one was appended. Mirrors the fields
// `resolveSmsProvider` reads in trackable-api.
export const INBOX_SMS_PROVIDER_QUERY = graphql(`
  query InboxSmsProvider($id: ID!) {
    location(id: $id) {
      id
      primaryTrackingNumber
      callRailCompanyId
      twilioNumbers {
        phone
      }
    }
  }
`)

// Super-user debug traces: the AI agent's conversation turns for a thread, each
// carrying the tool calls + tool results the agent made. `args` and `result` are
// JSON scalars (tools are defined dynamically per workflow) so they are rendered
// generically. Fetched only when a super user enables inbox debug mode.
export const DEBUG_TRACES_QUERY = graphql(`
  query InboxDebugTraces($threadId: ID, $sort: SortInput, $pagination: PaginationInput) {
    aiConversationTurns(threadId: $threadId, sort: $sort, pagination: $pagination) {
      hits {
        id
        messageId
        aiWorkflowId
        turnIndex
        createdDate
        isInitialMessage
        model
        temperature
        latencyMs
        response
        systemPrompt
        tokenUsage {
          inputTokens
          outputTokens
          totalTokens
          cachedInputTokens
          inputTokenDetails {
            cacheReadTokens
          }
        }
        steps {
          text
          toolCalls {
            toolName
            args
          }
          toolResults {
            toolName
            result
            isError
          }
        }
      }
      total
      page
    }
  }
`)

export const EMAIL_ATTACHMENT_URLS_QUERY = graphql(`
  query EmailAttachmentUrls($id: ID!) {
    emailAttachmentUrls(id: $id) {
      filename
      contentType
      sizeBytes
      url
    }
  }
`)

export const LOCATION_CAN_SEND_EMAIL_QUERY = graphql(`
  query LocationCanSendEmail($locationId: ID!) {
    locationCanSendEmail(locationId: $locationId)
  }
`)
